module.exports = __webpack_public_path__ + "static/img/10024.7a3fd894.png";